<template>
  <main class="main" v-loading="loading">
  		<div class="price_banner pc">
  			<div class="w1200">
  				<img class="pic1" src="../assets/product/banner_pro.png">
	  			<h1>云管家已涵盖<br>科教、文化、贸易等诸多行业</h1>
  			</div>
  			<img class="pic2" src="../assets/price/banner_river.png">
  		</div>
		<!-- <div class="w1200 product_carousel news_title">
		 	<p>相关案列</p>
			<el-carousel :interval="4000" height="500px" arrow="always" type="card">
			    <el-carousel-item>
				    <div class="product-img">
				  		<div>
				  			 <img src="../assets/news/school1.jpg" title="企业网站如何快速获得有效流量？" alt="企业网站如何快速获得有效流量？">
				  			<div class="mes">
				  				<p>看风景好学校</p>
				  				<span>企业官网建设排名是宣传品牌很重要的一个渠道，企业官网建设好之后，通过日积月累的优化工作或者直接竞拍排名，在搜索引擎搜索的时候有了很好的排名，...</span>
				  			</div>
				  		</div>
				  	</div>
			     
			    </el-carousel-item>
			    <el-carousel-item>
			    	<div class="product-img">
				  		<div>
				  			 <img src="../assets/news/school2.jpg" title="企业网站如何快速获得有效流量？" alt="企业网站如何快速获得有效流量？">
				  			<div class="mes">
				  				<p>看风景好学校</p>
				  				<span>企业官网建设排名是宣传品牌很重要的一个渠道，企业官网建设好之后，通过日积月累的优化工作或者直接竞拍排名，在搜索引擎搜索的时候有了很好的排名，...</span>
				  			</div>
				  		</div>
				  	</div>
			      
			    </el-carousel-item>
			    <el-carousel-item>
			    	<div class="product-img">
				  		<div>
				  			  <img src="../assets/news/school3.jpg" title="企业网站如何快速获得有效流量？" alt="企业网站如何快速获得有效流量？">
				  			<div class="mes">
				  				<p>看风景好学校</p>
				  				<span>企业官网建设排名是宣传品牌很重要的一个渠道，企业官网建设好之后，通过日积月累的优化工作或者直接竞拍排名，在搜索引擎搜索</span>
				  			</div>
				  		</div>
				  	</div>
			     
			    </el-carousel-item>
			</el-carousel>
		</div> -->
  		<div class="w1200 news_title">
  			<h1 class="title"><img src="../assets/zhineng.png">云管家·最佳案例</h1>
  			<div class="line"></div>
  			<!-- <div class="w1000">
  				<el-row :gutter="0" class="product_list">
				  <el-col :span="24">
				  	<div class="product-img">
				  		<div>
				  			<img src="../assets/product/school_fq.jpg">
				  			<div class="mes">
				  				<p>苏州市枫桥中学</p>
				  				<span>学校目前共有48个班级，2110名在校学生。在编在岗教师156人，其中女教师107人。教师队伍中高级职称52人、中级职称51人，中高级职称占全校教师的66%。学校现有苏州市名教师2人，大市学科带头人以上7人，区级学科带头人14人，区级教学能手13人，区级以上骨干教师共34人，占全校教师22%。拥有研究生学历者39人，占全校教师的25%。</span>
				  			</div>
				  		</div>
				  	</div>
				  </el-col>
				</el-row>
  			</div> -->
  		</div>
  		<div class="w1200 news_title">
  			<div class="w1000">
  				<el-row :gutter="0" class="product_list">
				  <el-col :span="24">
				  	<div class="product-img">
				  		<div>
				  			<img src="../assets/product/school_sz.jpg">
				  			<div class="mes">
				  				<p>苏州中学园区校</p>
				  				<span class="pc"> 苏州中学园区校是一所具有多元文化教育特色的国际化学校。它将最具互补性的东西两极文化的融合作为其核心；并且充分重视和逐步吸收其他各种文化的优秀成分。</span>
				  			</div>
				  		</div>
				  	</div>
				  </el-col>
				</el-row>
  			</div>
  		</div>
  		<div class="w1200 news_title">
  			<div class="w1000">
  				<el-row :gutter="0" class="product_list">
				  <el-col :span="24">
				  	<div class="product-img">
				  		<div>
				  			<img src="../assets/product/school_bq.jpg">
				  			<div class="mes">
				  				<p>北桥中学</p>
				  				<span></span>
				  			</div>
				  		</div>
				  	</div>
				  </el-col>
				</el-row>
  			</div>
  		</div>
		  <div class="w1200 news_title">
  			<div class="w1000">
  				<el-row :gutter="0" class="product_list">
				  <el-col :span="24">
				  	<div class="product-img">
				  		<div>
				  			<img src="../assets/product/school_sd.jpg">
				  			<div class="mes">
				  				<p>苏州大学第二实验学校</p>
				  				<span class="pc">苏州大学第二实验学校包括一所6轨36班的小学和一所16轨48班的初中。实验学校小学校区位于澄阳街道澄云路以东、蠡塘河路以南，今年9月将招生启用。实验学校中学校区则位于澄阳街道蠡塘河路以北、澄波路以东。</span>
				  			</div>
				  		</div>
				  	</div>
				  </el-col>
				</el-row>
  			</div>
  		</div>
		  <div class="w1200 news_title">
  			<div class="w1000">
  				<el-row :gutter="0" class="product_list">
				  <el-col :span="24">
				  	<div class="product-img">
				  		<div>
				  			<img src="../assets/product/school_tp.jpg">
				  			<div class="mes">
				  				<p>太平中学</p>
				  				<span class="pc">太平中学获准选址新建，现学校总面积150亩，总投资达5000万元。近年来，初中教育中取得巨大成功，2000 年、 2001 年、 2002 年获中考综合考评相城区第一名， 2003 年又获相城区中考综合考评一等奖。连续五年获相城区“常规管理先进学校”；</span>
				  			</div>
				  		</div>
				  	</div>
				  </el-col>
				</el-row>
  			</div>
  		</div>
		  <div class="w1200 news_title">
  			<div class="w1000">
  				<el-row :gutter="0" class="product_list">
				  <el-col :span="24">
				  	<div class="product-img">
				  		<div>
				  			<img src="../assets/product/school_xc.jpg">
				  			<div class="mes">
				  				<p>苏州市相城第三实验中学</p>
				  				<span></span>
				  			</div>
				  		</div>
				  	</div>
				  </el-col>
				</el-row>
  			</div>
  		</div>
		  <div class="w1200 news_title">
  			<div class="w1000">
  				<el-row :gutter="0" class="product_list">
				  <el-col :span="24">
				  	<div class="product-img">
				  		<div>
				  			<img src="../assets/product/school_xw.jpg">
				  			<div class="mes">
				  				<p>苏州工业园区星湾学校</p>
				  				<span class="pc">星湾学校是苏州工业园区管委会直属的九年制公立学校。学校占地5.3万平方米，总建筑面积4.3万平方米，总投资2亿元。星湾学校按现代化标准建造，所有教室均配备液晶投影和实物展示平台。</span>
				  			</div>
				  		</div>
				  	</div>
				  </el-col>
				</el-row>
  			</div>
  		</div>
		  <div class="w1200 news_title">
  			<div class="w1000">
  				<el-row :gutter="0" class="product_list">
				  <el-col :span="24">
				  	<div class="product-img">
				  		<div>
				  			<img src="../assets/product/school_xy.jpg">
				  			<div class="mes">
				  				<p>苏州工业园区星洋学校</p>
				  				<span></span>
				  			</div>
				  		</div>
				  	</div>
				  </el-col>
				</el-row>
  			</div>
  		</div>
<!--   		<div class="price_yours">
  			<h2>没有合适方案？您可以联系我们，根据您的实际情况定制…</h2>
  			<button class="btn">联系我们</button>
  		</div> -->
  	</main>
  	
</template>

<script>
export default {
  name: 'product',
  data () {
    return {
		loading:true
		// list:[{
		// 	name:'',
		// 	img:'school_bq.jpg',
		// 	content:''
		// },{
		// 	name:'',
		// 	img:'school_fq.jpg',
		// 	content:''
		// },{
		// 	name:'',
		// 	img:'school_sd.jpg',
		// 	content:''
		// },{
		// 	name:'',
		// 	img:'school_tp.jpg',
		// 	content:''
		// },{
		// 	name:'',
		// 	img:'school_xc.jpg',
		// 	content:''
		// },{
		// 	name:'',
		// 	img:'school_xw.jpg',
		// 	content:''
		// },{
		// 	name:'',
		// 	img:'school_xy.jpg',
		// 	content:''
		// }]
    }
  },
  mounted(){
	  this.loading=false
  }
}
</script>


// WEBPACK FOOTER //
// src/components/product.vue